import { css } from "@emotion/react";
import { FC } from "react";

import BackLink from "~/components/item/[id]/BackLink";
import ResponseContent from "~/components/item/[id]/response-content";
import { Props } from "~/components/item/page/[id]/lib";

const MobilePage: FC<Props> = ({ response }) => {
  return (
    <main css={rootStyle}>
      <BackLink form={response.form} />
      <ResponseContent
        questions={response.form.questions}
        response={response}
      />
    </main>
  );
};

const rootStyle = css`
  padding: 1rem;
`;

const contentStyle = css`
  display: flex;
  justify-content: center;
  flex-flow: column;
  align-items: center;
`;

export default MobilePage;
